var React = require('react');

function ArrowLeftBlack (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("g",null,React.createElement("image",{"width":"36","height":"9","xlinkHref":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAJCAYAAABaMo5wAAAAgUlEQVQ4T2NkQAIKMgrmjIz/ezl5uZ2uXbv2C1mOXmxGmEVycnLGTP8Z9zEwMrY/ePSgg14OQLcH7CAlGRndv4zM+xgZGXsH0jEgtzCCHPOPkXk/AwPDIgZmxqaBChmYvYwKsvLXGBgY1BgYGJgH2jGDM4QGXRoalLkM5qjBUA4BAH8QLEVXix3fAAAAAElFTkSuQmCC"}))));
}

ArrowLeftBlack.defaultProps = {"width":"36","height":"9","viewBox":"0 0 36 9"};

module.exports = ArrowLeftBlack;

ArrowLeftBlack.default = ArrowLeftBlack;
